const setInlineCssVars = ( ( document, window ) => {
	const setCSSVariables = () => {
		const root = document.documentElement;
		const topBarBox = document.querySelector( '.top-bar' );
		const siteHeaderBox = document.querySelector( '.site-header' );
		const siteHero = document.querySelector(
			'.wp-block-licht-concept-blocks-hero'
		);
		const scrollbarWidth =
			window.innerWidth - document.documentElement.clientWidth;

		root.style.setProperty( '--scrollbar', `${ scrollbarWidth }px` );
		if ( topBarBox ) {
			root.style.setProperty(
				'--top-bar-block-size',
				`${ topBarBox.clientHeight }px`
			);
		}
		if ( siteHeaderBox ) {
			root.style.setProperty(
				'--scroll-padding-block-size',
				`${ siteHeaderBox.clientHeight + 20 }px`
			);
			if ( siteHero ) {
				siteHero.style.setProperty(
					'--site-header-block-size',
					`${ siteHeaderBox.clientHeight + 21 }px`
				);
			}
		}
	};

	const init = () => {
		setCSSVariables();
		window.addEventListener( 'resize', setCSSVariables );
	};

	window.addEventListener( 'DOMContentLoaded', init );

	return {
		init,
	};
} )( document, window );

export default setInlineCssVars;
